import React from "react";
import PropTypes from 'prop-types';
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import {Button} from "reactstrap";

class LocationCard extends React.PureComponent {
	static propTypes = {
		name: PropTypes.string.isRequired,
		description: PropTypes.string,
		inStockQuantity: PropTypes.number.isRequired,
		boundBookRouteID: PropTypes.string.isRequired,
		boundBookDownloadRouteID: PropTypes.string.isRequired,
		onBoundBookClick: PropTypes.func.isRequired,
		onBoundBookDownloadClick: PropTypes.func.isRequired,
	};

	static defaultProps = {
		name: '',
		description: '',
		inStockQuantity: 0,
	};

	render() {
		const {
			name,
			description,
			inStockQuantity,
			onBoundBookClick,
			onBoundBookDownloadClick,
			boundBookRouteID,
			boundBookDownloadRouteID,
		} = this.props;

		return (
			<Card style={{
				backgroundColor: '#67809f',
				border: '3px solid',
				borderColor: '#a2a2a2',
				width: '280px',
				display: 'inline-block',
				marginRight: '20px'
			}}>
				<CardContent style={{padding: '8px 8px 4px', height: '70px'}}>
					<p style={{
						fontSize: '17px',
						fontWeight: '300',
						marginBottom: '0',
						color: 'white'
					}} className="nav-text">
						{name}
					</p>
					{description ?
						<span style={{
							fontSize: '12px',
							color: 'white'
						}}>
							{description}
						</span> : null}
				</CardContent>
				<CardActions style={{padding: '4px 8px 8px'}}>
					<span style={{
						marginRight: 'auto',
						color: 'white',
						fontSize: '10px',
						width: 'auto',
						lineHeight: '12px',
						marginTop: '4px'
					}}>
						<i>In Stock Firearms:</i><br/>
						<b>{inStockQuantity}</b>
					</span>
					<Button
						onClick={onBoundBookClick}
						id={"button-login"}
						name={boundBookRouteID}
						color="green-meadow"
						size={"sm"}>
						<i className="fa fa-book"/>
					</Button>
					<Button
						onClick={onBoundBookDownloadClick}
						name={boundBookDownloadRouteID}
						color="primary"
						size={"sm"}>
						<i className="fa fa-download"/>
					</Button>
				</CardActions>
			</Card>
		);
	}
}

export default LocationCard;
